export const SENTRY_DSN =
  'https://a1f56c5963cb40a0afc7a87b9c9a7e10@o1280981.ingest.sentry.io/6510053';
